'use client';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '@bridebook/aura';
import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { useRadioGroupContext } from '../radio-group/radio-group-context';
import { radioDotVariants, radioVariants } from './radio-variants';

export type RadioProps = ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
  error?: boolean;
};

export const Radio = forwardRef<ElementRef<typeof RadioGroupPrimitive.Item>, RadioProps>(
  ({ disabled, error: errorProp, className, ...props }, ref) => {
    const { error: groupError } = useRadioGroupContext();

    const error = !!groupError || errorProp;

    return (
      <RadioGroupPrimitive.Item
        data-slot="radio-group-item"
        className={cn(
          radioVariants({ size: 'standard' }),
          'group outline-none group-aria-invalid:border-border-error hover:border-border-active focus-visible:ring-[3px] focus-visible:ring-focus-ring aria-invalid:border-border-error data-[disabled]:cursor-not-allowed data-[disabled]:border-action-primary-disabled',
          className,
        )}
        disabled={disabled}
        aria-invalid={error}
        ref={ref}
        {...props}>
        <RadioGroupPrimitive.Indicator
          data-slot="radio-group-indicator"
          className="relative flex items-center justify-center">
          <div
            className={cn(
              radioDotVariants({ size: 'standard', disabled }),
              'group-data-[disabled]:bg-action-primary-disabled',
            )}
          />
        </RadioGroupPrimitive.Indicator>
      </RadioGroupPrimitive.Item>
    );
  },
);
Radio.displayName = RadioGroupPrimitive.Item.displayName;

export { radioDotVariants, radioVariants, type RadioSize } from './radio-variants';
export { RadioIndicator, type RadioIndicatorProps } from './radio-indicator';
